import { borderRadius, breakpoints } from '@toggle/design-system';
import styled from 'styled-components';

export const Chevron = styled.div<{ isScrolledToEnd: boolean }>`
  position: absolute;
  opacity: 0;
  top: 50%;
  ${props => (props.isScrolledToEnd ? 'left:5px' : 'right:5px')};
  display: none;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  ${borderRadius.rFull};
  transform: translateY(-50%);
  background-color: rgba(49, 49, 51, 0.95);
  transition: all 150ms ease-in-out;
  cursor: pointer;

  & > svg {
    fill: var(--icon-soft);
  }

  &:hover {
    background-color: rgba(47, 48, 49, 1);
  }

  @media ${breakpoints.lg} {
    display: inline-flex;
  }
`;

export const ChipsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  user-select: none;
  touch-action: pan-x;
  min-height: 60px;
  background: var(--background-default);
  scrollbar-width: none;
  overflow-x: auto;
  white-space: nowrap;

  > div:not(:last-child) {
    margin-right: 12px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${breakpoints.lg} {
    min-height: unset;
    padding: 12px 16px 11px;
    border-bottom: 1px solid var(--border-soft);
    background: var(--surface-default);
    margin-bottom: 0px;
  }
`;

export const Container = styled.div`
  padding: 0px 16px;

  @media ${breakpoints.lg} {
    position: absolute;
    top: 0;
    width: 100%;
    padding: 0px;

    &:hover ${Chevron} {
      opacity: 1;
    }
  }
`;
